import { getStoreLocation } from '../utils/platformConfig';

/** Default map center — updates when admin saves platform settings */
export const getMapCenter = () => getStoreLocation();

/** @deprecated use getMapCenter() */
export const STORE_LOCATION = { lat: 13.6561836, lng: 78.9397511 };

/** @deprecated use getMapCenter() */
export const PILER_CENTER = STORE_LOCATION;

export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY || '';

export const hasGoogleMapsKey = () => Boolean(GOOGLE_MAPS_API_KEY);

export const DEFAULT_MAP_ZOOM = 17;

export const MAP_CONTAINER_STYLE = {
  width: '100%',
  height: '240px',
  borderRadius: '12px',
};
